import axios from "axios";

export function getPlanningEntries(athlete_id: number = 0, from: string = '', to: string = '') {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/planning-entry';
    const params = [];
    if (athlete_id != 0) {
        params.push('athlete_id=' + athlete_id);
    }
    if (from.length > 0) {
        params.push('from=' + from);
    }
    if (to.length > 0) {
        params.push('to=' + to);
    }
    if (params.length > 0) {
        endpointUrl += '?' + params.join('&');
    }
    return axios.get(endpointUrl, { headers: headers } );
}

export function createPlanningEntry(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/planning-entry';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function createBulkPlanningEntries(entries: any[]) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/planning-entry-bulk';
    return axios.post(endpointUrl, JSON.stringify({ entries }), { headers: headers });
}

export function updatePlanningEntry(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/planning-entry';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deletePlanningEntry(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/planning-entry/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}

export function deleteBulkPlanningEntries(days: {athlete_id: number, day: string}[]) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/planning-entry-bulk';
    return axios.delete(endpointUrl, { headers: headers, data: JSON.stringify(days) });
}

export function getCoachPlanning(coach: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/coach-planning/' + coach;
    return axios.get(endpointUrl, { headers: headers } );
}

export function getAthletePlanning(coach: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/athlete-planning/' + coach;
    return axios.get(endpointUrl, { headers: headers } );
}